<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="city && city.id">{{ 'CITIES.CITIES_FORM.EDIT_CITY' | translate }}</span>
    <span *ngIf="!city || !city.id">{{ 'CITIES.CITIES_FORM.ADD_CITY' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="cities-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-6">
        <google-map
          *ngIf="form && form.get('lat').value && form.get('long').value"
          class="agm-map"
          height="365px"
          width="365px"
          [center]="{
            lat: number(this.form.get('lat').value),
            lng: number(this.form.get('long').value),}
          ">
          <map-marker
            [position]="{
            lat: number(this.form.get('lat').value),
            lng: number(this.form.get('long').value),}
            "
            [title]="this.form.value.name"
            [options]="{draggable: true }"
            (mapDragend)="selectLocation($event)"
          >
          </map-marker>
        </google-map>
        <div class="map-placeholder" *ngIf="!form?.get('lat')?.value || !form?.get('long')?.value"></div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label>{{ 'CITIES.CITIES_FORM.NAME' | translate }}</label>
          <!--          TODO: SEND THE FORM NAME CORRECTLY FOR EDIT FUNCTIONALITY -->
          <app-google-places-autocomplete (placeSelected)="handleCityChange($event)"
                                          [initialValue]="form.get('name').value"
                                          [countryCode]="country?.code"
                                          [placeTypes]="['(cities)']"
          ></app-google-places-autocomplete>
        </div>

        <div class="form-group">
          <label>{{ 'CITIES.CITIES_FORM.ALTERNATENAMES' | translate }}</label>
          <input type="text" class="form-control" formControlName="alternatenames" />
        </div>

        <div class="form-group">
          <label>{{ 'CITIES.CITIES_FORM.LAT' | translate }}</label>
          <input type="number" class="form-control" formControlName="lat" />
        </div>

        <div class="form-group">
          <label>{{ 'CITIES.CITIES_FORM.LONG' | translate }}</label>
          <input type="number" class="form-control" formControlName="long" />
        </div>

        <app-countries-select [parentFormGroup]="form"></app-countries-select>

        <app-timezone-select [parentFormGroup]="form"></app-timezone-select>

        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input" formControlName="active" />
          <label class="form-check-label">{{ 'CITIES.CITIES_FORM.ACTIVE' | translate }}</label>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="cities-form" [disabled]="form.invalid">
    {{ 'CITIES.CITIES_FORM.SAVE' | translate }}
  </button>
</div>
